import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.api';

export const clientApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [
		EBaseApiTags.CLIENT_TASKS,
		EBaseApiTags.CLIENT_TASK,
		EBaseApiTags.CLIENT_OFFER,
		EBaseApiTags.CLIENT_OFFERS,
		EBaseApiTags.TIMELINE,
	],
	endpoints: {
		clientOffersTasksList: {
			providesTags: [EBaseApiTags.CLIENT_TASKS],
		},
		clientTasksRetrieve: {
			providesTags: [EBaseApiTags.CLIENT_TASK],
		},
		clientTasksUpdate: {
			invalidatesTags: (_: unknown, error: unknown) => (error ? [] : [EBaseApiTags.TIMELINE, EBaseApiTags.CLIENT_TASK]),
		},
		clientTasksCommentsCreate: {
			invalidatesTags: (_: unknown, error: unknown) => (error ? [] : [EBaseApiTags.TIMELINE]),
		},
		clientTasksTimelineList: {
			providesTags: [EBaseApiTags.TIMELINE],
		},
		clientOffersList: {
			providesTags: [EBaseApiTags.CLIENT_OFFERS],
		},
		clientOffersRetrieve: {
			providesTags: [EBaseApiTags.CLIENT_OFFER],
		},
		clientOffersCreate: {
			invalidatesTags: (_: unknown, error: unknown) => (error ? [] : [EBaseApiTags.CLIENT_OFFERS, EBaseApiTags.CLIENT_OFFER]),
		},
		clientOffersPublishCreate: {
			invalidatesTags: (_: unknown, error: unknown) => (error ? [] : [EBaseApiTags.CLIENT_OFFERS, EBaseApiTags.CLIENT_OFFER]),
		},
		// offersProceedCreate: {
		// 	invalidatesTags: (_: unknown, error: unknown) => (error ? [] : [EBaseApiTags.TASK]),
		// },
	},
});
export const {
	useClientOffersTasksListQuery,
	useClientTasksRetrieveQuery,
	useClientTasksUpdateMutation,
	useClientTasksCommentsCreateMutation,
	useClientTasksTimelineListQuery,
	useClientOffersListQuery,
	useClientOffersRetrieveQuery,
	useClientOffersCreateMutation,
	useClientOffersPublishCreateMutation,
	useLazyClientOffersTasksListQuery,
} = clientApi;
